const categoryCards = document.querySelectorAll('.category-card');
categoryCards.forEach(categoryCard => {
  categoryCard.addEventListener('focusin', (e) => {
    e.target.style.filter = 'grayscale(100%)';
  });
  categoryCard.addEventListener('focusout', (e) => {
    e.target.style.filter = '';
  });
})